import React, { Fragment } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ImageAdvertise from "../advertise/imageAdvertise";
import VideoPreview from "../video/videoPreview";
import AboutInfoCard from "../aboutUsCard/aboutInfoCard";
import "../../assets/css/scss/section/_adverticeAboutUs.scss";

export default function AdverticeAboutUsSection() {
  return (
    <Fragment>
      <section className="about-section theme-light-black">
        <Container>
          <Row>
            <Col md={4} lg={2} className="d-none d-md-block">
              <ImageAdvertise />
            </Col>
            <Col md={8} lg={5}>
              <VideoPreview />
            </Col>
            <Col lg={5} className="mt-3 mt-md-4 mt-lg-0">
              <AboutInfoCard />
            </Col>
          </Row>
        </Container>
      </section>
    </Fragment>
  );
}
